
import draggable from "vuedraggable";
import { Component, Vue } from "vue-property-decorator";
const message = ["vue.draggable", "draggable", "component", "for", "vue.js 2.0", "based", "on", "Sortablejs"];

@Component({ components: { draggable } })
export default class ServiceList extends Vue {
  name = "transition-example-2";
  display = "Transitions";
  order = 7;
  list = message.map((name, index) => {
    return { name, order: index + 1 };
  });
  drag = false;

  sort() {
    this.list = this.list.sort((a, b) => a.order - b.order);
  }

  get dragOptions() {
    return {
      animation: 200,
      group: "description",
      disabled: false,
      ghostClass: "ghost"
      // direction: "horizontal"
    };
  }
}
